// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"f499ba90","513":"1d018a0f","605":"914033e0","706":"773da0a0","827":"36c37ce7"}[chunkId] + ".chunk.js";
};